import environment from '../helpers/configEnv'

export const executePostEndpoint = async (body, jwtToken, endpoint) => {
    const API_ENDPOINT = environment.apiEndpoint;
    try {
        const response = await fetch(`${API_ENDPOINT}${endpoint}`, {
            method: 'POST',
            headers: {
                'Authorization': jwtToken,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ body }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        console.log('Response headers:', [...response.headers.entries()]);

        const data = await response.json();
        return data.results;
    } catch (error) {
        console.error('Error executing POST Endpoint:', error);
        throw error;
    }
};